module.exports = __webpack_public_path__ + "img/eye.3ccb1954.svg";